import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { OrderItem } from '@usf/ngrx-order';
import { Observable } from 'rxjs';
import { OrderService } from 'src/app/order/services/order.service';
import { getCarouselImages } from 'src/app/product-detail/utils/product-images.util';
import { QuantityUpdate } from 'src/app/shared/models/quantity-update';
import { NavigationHelperService } from '../../helpers/navigation.helpers.service';
import { Product } from '../../models/product.model';
import { UsfProductCardModeEnum } from '../../constants/usf-product-card-mode.enum';
import { ItemTypes } from '../../../lists/shared/list-detail-management/model/list-detail-management-view.model';
import { EllipsisClickData } from '../../models/usf-product-card.model';
import { DealsProductCardService } from '../../services/product-card/deals-product-card.service';
import { ImageModel } from '@shared/models/image.model';
import { ImageVariantEnum } from '@product-detail/models/image-variant.enum';

@Component({
  selector: 'app-product-detail-cab-card',
  templateUrl: './product-detail-cab-card.component.html',
  styleUrls: ['./product-detail-cab-card.component.scss'],
})
export class ProductDetailCABCardComponent implements OnInit {
  @Input() product: Product;
  @Input() isDisable = false;
  @Output() quantityUpdateEmitter = new EventEmitter<QuantityUpdate>();
  @Output() productImageClickEmitter = new EventEmitter<Product>();
  @Input() lnkSrc: string;
  @Input() merchRank: number;
  @Input() variant: string;
  @Input() showPromotionDetailInTablet = false;
  @Input() isGuestUser = false;

  hasPromotionDetails = false;

  imageUrl: string;
  alternativeImageUrl: ImageModel[];
  productDescriptionNotAvailableMessage: string;
  productBrandNotAvailableMessage: string;
  orderItem$: Observable<OrderItem>;

  ImageVariantEnum = ImageVariantEnum;

  constructor(
    private translateService: TranslateService,
    private navigationService: NavigationHelperService,
    private readonly orderService: OrderService,
    readonly platformService: PlatformService,
    private dealsProductCardService: DealsProductCardService,
  ) {}

  ngOnInit(): void {
    this.translate();
    this.alternativeImageUrl = getCarouselImages(this.product?.summary);
    this.orderItem$ = this.orderService.getOrderItemWithProductNumber$(
      this.product?.productNumber,
    );
    this.hasPromotionDetails =
      !!this.product?.promotionDetails?.offerBenefitDesc;
  }

  getAlternativeMainImage(imageUrl: string): string {
    const availImages = this.alternativeImageUrl?.find(
      (v, i) => v.urls.small != imageUrl,
    );
    return availImages?.urls.small;
  }

  translate() {
    this.productDescriptionNotAvailableMessage = this.translateService.instant(
      'i18n.productDetail.productDescriptionNotAvailableMessage',
    );
    this.productBrandNotAvailableMessage = this.translateService.instant(
      'i18n.productDetail.productBrandNotAvailableMessage',
    );
  }

  navigateToProductPage() {
    const { productNumber } = this.product;
    if (productNumber) {
      if (this.lnkSrc) {
        const queryParams = {
          lnksrc: this.lnkSrc,
          merchRank: this.merchRank,
          variant: this.variant,
        };
        !this.merchRank && delete queryParams.merchRank;
        !this.variant && delete queryParams.variant;
        this.navigationService.routeToProductDetailsQueryParams(
          productNumber,
          queryParams,
        );
      } else {
        this.navigationService.routeToProductDetails(productNumber);
      }
    }
  }

  onProductImageClick() {
    this.productImageClickEmitter.emit({
      ...this.product,
      resultRank: this.merchRank,
    });
    this.navigateToProductPage();
  }

  changeQuantityHandler(quantityUpdate: QuantityUpdate) {
    this.quantityUpdateEmitter.emit(quantityUpdate);
  }

  clickPromotions(event: Event) {
    const ellipsisClickData = {
      event,
      product: this.product,
      mode: UsfProductCardModeEnum.defaultSearch,
      pricingDisabled: false,
      isSelected: false,
      itemType: ItemTypes.product,
      list: null,
      isTouch: this.platformService.isTouch.value,
    } as EllipsisClickData;
    if (this.hasPromotionDetails && this.showPromotionDetailInTablet) {
      this.dealsProductCardService.openQuickViewModal(
        ellipsisClickData,
        'productStatus',
      );
    } else if (
      this.hasPromotionDetails &&
      !this.showPromotionDetailInTablet &&
      !this.platformService.isTouch.value
    ) {
      this.dealsProductCardService.openQuickViewModal(
        ellipsisClickData,
        'productStatus',
      );
    }
  }
}
